export const typeOfChangeChanged = (data) => fetch(`/changecustomer/typeOfChangeChanged`, {
    method: "post",
    body: JSON.stringify(data),
    headers: {
        "content-type": "application/json"
    }
}).then(res => {
    return res;
});
//# sourceMappingURL=TypeOfChangeChanged.js.map